import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@app/services';
import { PayrollReport } from '@reporting/interfaces/report.interface';
import camelcaseKeys from 'camelcase-keys';
import { saveAs } from 'file-saver';
import { stringify } from 'qs/dist/qs';
import { ReportOptions } from '../interfaces/report-options.interface';

const qsOptions = {
    indices: true,
};

@Injectable()
export class PayrollReportingService {
    private apiBaseUrl = '/v2/reportManagement';

    constructor(
        private http: HttpClient,
        private auth: AuthService
    ) {}

    async display(report: PayrollReport, queryParams: ReportOptions): Promise<Object> {
        const queryString = stringify(queryParams, qsOptions);

        return this.http.get(`${this.endpointUrlFor(report)}?${queryString}`).toPromise();
    }

    exportExcel(report: PayrollReport, queryParams: ReportOptions): void {
        this.export(report, queryParams, 'xlsx');
    }

    exportPDF(report: PayrollReport, queryParams: ReportOptions): void {
        this.export(report, queryParams, 'pdf');
    }

    exportCSV(report: PayrollReport, queryParams: ReportOptions): void {
        this.export(report, queryParams, 'csv');
    }

    export(report: PayrollReport, queryParams: ReportOptions, fileType: string): void {
        queryParams.export = fileType;
        const queryString = stringify(camelcaseKeys(queryParams, { exclude: [/\./] }), qsOptions);
        this.http
            .get(`${this.apiBaseUrl}/companies/${this.auth.company.id}/${report.apiEndpoint}?` + queryString, {
                responseType: 'blob',
            })
            .toPromise()
            .then((blob: Blob) => {
                saveAs(blob, `${report.fileName}.${fileType}`);
            });
    }

    private endpointUrlFor(report: PayrollReport): string {
        return `${this.apiBaseUrl}/companies/${this.auth.company.id}/${report.apiEndpoint}`;
    }
}
